// 都道府県定義データ
export const prefectures = [
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県"
]
// nonFleet等級(保険未加入時)データ
export const nonFleetS = [
  ["06S", "6S（初めてご契約される方はこちら）"],
  ["07S", "7S"]
]
// nonFleet等級(保険加入時)データ
export const nonFleetF = [
  ["020", "20"],
  ["019", "19"],
  ["018", "18"],
  ["017", "17"],
  ["016", "16"],
  ["015", "15"],
  ["014", "14"],
  ["013", "13"],
  ["012", "12"],
  ["011", "11"],
  ["010", "10"],
  ["009", "09"],
  ["008", "08"],
  ["07F", "7F"],
  ["06F", "6F"],
  ["005", "05"],
  ["004", "04"],
  ["003", "03"],
  ["002", "02"]
]
// 運転者範囲の選択組み合わせ分類パターンA
export const driverScopeA = [false, false, false, false, false, false, false]
// 運転者範囲の選択組み合わせ分類パターンB
export const driverScopeB = [
  [true, false, false, false, false, false, false],
  [false, false, true, false, false, false, false],
  [true, false, true, false, false, false, false]
]
// 運転者範囲の選択組み合わせ分類パターンC
export const driverScopeC = [
  [false, false, false, true, false, false, false],
  [true, false, false, true, false, false, false],
  [false, false, true, true, false, false, false],
  [true, false, true, true, false, false, false],
  [false, false, false, false, true, false, false],
  [true, false, false, false, true, false, false],
  [false, false, true, false, true, false, false],
  [true, false, true, false, true, false, false],
  [false, false, false, true, true, false, false],
  [true, false, false, true, true, false, false],
  [false, false, true, true, true, false, false],
  [true, false, true, true, true, false, false],
  [false, false, false, false, false, true, false],
  [true, false, false, false, false, true, false],
  [false, false, true, false, false, true, false],
  [true, false, true, false, false, true, false],
  [false, false, false, true, false, true, false],
  [true, false, false, true, false, true, false],
  [false, false, true, true, false, true, false],
  [true, false, true, true, false, true, false],
  [false, false, false, false, true, true, false],
  [true, false, false, false, true, true, false],
  [false, false, true, false, true, true, false],
  [true, false, true, false, true, true, false],
  [false, false, false, true, true, true, false],
  [true, false, false, true, true, true, false],
  [false, false, true, true, true, true, false],
  [true, false, true, true, true, true, false]
]
// 運転者範囲の選択組み合わせ分類パターンD
export const driverScopeD = [
  [false, true, false, false, false, false, false],
  [true, true, false, false, false, false, false],
  [false, true, true, false, false, false, false],
  [true, true, true, false, false, false, false],
  [false, true, false, true, false, false, false],
  [true, true, false, true, false, false, false],
  [false, true, true, true, false, false, false],
  [true, true, true, true, false, false, false],
  [false, true, false, false, true, false, false],
  [true, true, false, false, true, false, false],
  [false, true, true, false, true, false, false],
  [true, true, true, false, true, false, false],
  [false, true, false, true, true, false, false],
  [true, true, false, true, true, false, false],
  [false, true, true, true, true, false, false],
  [true, true, true, true, true, false, false],
  [false, true, false, false, false, true, false],
  [true, true, false, false, false, true, false],
  [false, true, true, false, false, true, false],
  [true, true, true, false, false, true, false],
  [false, true, false, true, false, true, false],
  [true, true, false, true, false, true, false],
  [false, true, true, true, false, true, false],
  [true, true, true, true, false, true, false],
  [false, true, false, false, true, true, false],
  [true, true, false, false, true, true, false],
  [false, true, true, false, true, true, false],
  [true, true, true, false, true, true, false],
  [false, true, false, true, true, true, false],
  [true, true, false, true, true, true, false],
  [false, true, true, true, true, true, false],
  [true, true, true, true, true, true, false],

  [false, false, false, false, false, false, true],
  [true, false, false, false, false, false, true],
  [false, false, true, false, false, false, true],
  [true, false, true, false, false, false, true],
  [false, false, false, true, false, false, true],
  [true, false, false, true, false, false, true],
  [false, false, true, true, false, false, true],
  [true, false, true, true, false, false, true],
  [false, false, false, false, true, false, true],
  [true, false, false, false, true, false, true],
  [false, false, true, false, true, false, true],
  [true, false, true, false, true, false, true],
  [false, false, false, true, true, false, true],
  [true, false, false, true, true, false, true],
  [false, false, true, true, true, false, true],
  [true, false, true, true, true, false, true],
  [false, false, false, false, false, true, true],
  [true, false, false, false, false, true, true],
  [false, false, true, false, false, true, true],
  [true, false, true, false, false, true, true],
  [false, false, false, true, false, true, true],
  [true, false, false, true, false, true, true],
  [false, false, true, true, false, true, true],
  [true, false, true, true, false, true, true],
  [false, false, false, false, true, true, true],
  [true, false, false, false, true, true, true],
  [false, false, true, false, true, true, true],
  [true, false, true, false, true, true, true],
  [false, false, false, true, true, true, true],
  [true, false, false, true, true, true, true],
  [false, false, true, true, true, true, true],
  [true, false, true, true, true, true, true],
  [false, true, false, false, false, false, true],
  [true, true, false, false, false, false, true],
  [false, true, true, false, false, false, true],
  [true, true, true, false, false, false, true],
  [false, true, false, true, false, false, true],
  [true, true, false, true, false, false, true],
  [false, true, true, true, false, false, true],
  [true, true, true, true, false, false, true],
  [false, true, false, false, true, false, true],
  [true, true, false, false, true, false, true],
  [false, true, true, false, true, false, true],
  [true, true, true, false, true, false, true],
  [false, true, false, true, true, false, true],
  [true, true, false, true, true, false, true],
  [false, true, true, true, true, false, true],
  [true, true, true, true, true, false, true],
  [false, true, false, false, false, true, true],
  [true, true, false, false, false, true, true],
  [false, true, true, false, false, true, true],
  [true, true, true, false, false, true, true],
  [false, true, false, true, false, true, true],
  [true, true, false, true, false, true, true],
  [false, true, true, true, false, true, true],
  [true, true, true, true, false, true, true],
  [false, true, false, false, true, true, true],
  [true, true, false, false, true, true, true],
  [false, true, true, false, true, true, true],
  [true, true, true, false, true, true, true],
  [false, true, false, true, true, true, true],
  [true, true, false, true, true, true, true],
  [false, true, true, true, true, true, true],
  [true, true, true, true, true, true, true]
]
